import { Crisp } from "crisp-sdk-web"
import { useEffect } from "react"

const isCrispEnabled = (): boolean =>
  import.meta.env.MODE !== "development" &&
  Boolean(import.meta.env.VITE_CRISP_WEBSITE_ID)

/**
 * Loads Crisp on supplier shells and hides it when leaving for brand/admin routes.
 * The SDK injects a global widget; without cleanup it stays visible after SPA navigation.
 */
export const useSupplierCrispChat = (): void => {
  useEffect(() => {
    if (!isCrispEnabled()) {
      return
    }

    Crisp.configure(import.meta.env.VITE_CRISP_WEBSITE_ID)
    Crisp.chat.show()

    return () => {
      Crisp.chat.hide()
    }
  }, [])
}
